/**
 * User-visible copy for reminder flows (FAB, profile edit, sheets).
 * Centralise literals here so copy stays consistent and is easier to wire to i18n later.
 */

/** Left / dismiss action on small confirm bottom sheets. */
export const REMINDER_CONFIRM_LABEL_NO = "No";

/** Default right / confirm action when {@link REMINDER_SAVE_DRAWER_CLOSE_CONFIRM_PRIMARY_LABEL} is not overridden. */
export const REMINDER_CONFIRM_LABEL_YES = "Yes";

/**
 * Shown when closing the save-relation sheet after the user has saved at least one occasion date in the session.
 */
export const REMINDER_SAVE_DRAWER_CLOSE_CONFIRM_MESSAGE = "Would you like to save the occasion details?";

/**
 * Primary action for {@link REMINDER_SAVE_DRAWER_CLOSE_CONFIRM_MESSAGE} (right button; left is {@link REMINDER_CONFIRM_LABEL_NO}).
 */
export const REMINDER_SAVE_DRAWER_CLOSE_CONFIRM_PRIMARY_LABEL = "Save";

/** Toast: FAB flow after confirming a new relation in the picker. */
export const REMINDER_TOAST_RELATION_ADDED_FAB_HEADER = "Relation added successfully";

/** Toast: profile route after confirming relation (shorter variant). */
export const REMINDER_TOAST_RELATION_ADDED_PROFILE_HEADER = "Relation added";

/** Toast: single-occasion save from profile / occasion edit. */
export const REMINDER_TOAST_OCCASION_SAVED = "Occasion saved successfully";

/** Toast: full profile save on profile route. */
export const REMINDER_TOAST_PROFILE_SAVED = "Profile saved successfully";

// --- Relation picker (`ReminderFabRelationPickerDrawer`) ---

/** Default title when no profile name is passed. */
export const REMINDER_RELATION_PICKER_HEADING_DEFAULT = "Choose your relation";

export const REMINDER_ALL_OCCASIONS_POPUP_HEADING = "All occasions";

export const MY_REMINDERS_HEADING = "My Reminders";

export const REMINDER_VIEW_MODE_SET = "viewModeSet";
/**
 * Relation picker title; personalized when opened from a dashboard profile plus tile.
 *
 * @param {string|undefined|null} recipientName
 * @returns {string}
 */
export function formatReminderRelationPickerHeading(recipientName) {
  const name = recipientName != null ? String(recipientName).trim() : "";
  if (!name) {
    return REMINDER_RELATION_PICKER_HEADING_DEFAULT;
  }
  return `Choose ${name}'s relation`;
}

// --- FAB "Add occasions" bottom sheet (`ReminderFabAddOccasionsDrawer`) ---

/** Sheet title when no `heading` prop is passed. */
export const REMINDER_ADD_OCCASIONS_DRAWER_HEADING = "Let's add your occasions";

export const REMINDER_ADD_OCCASIONS_QUICK_ADD_TITLE = "Quick Add";

export const REMINDER_ADD_OCCASIONS_QUICK_ADD_SUBTITLE = "Save your important occasions in one go";

export const REMINDER_ADD_OCCASIONS_CALENDAR_TITLE = "Add from Calendar";

export const REMINDER_ADD_OCCASIONS_CALENDAR_SUBTITLE = "Import from your iPhone & Google calendars";

export const REMINDER_ADD_OCCASIONS_CONTACTS_TITLE = "Add from Contacts";

export const REMINDER_ADD_OCCASIONS_CONTACTS_SUBTITLE = "Import occasions saved in your contacts";

export const REMINDER_ADD_RELATION_TITLE = "Relation";
